import { v5 as uuidv5, v7 as uuidv7, validate as uuidValidate } from 'uuid';
/**
 * Identifiers are generated on the client (docs/08 §1):
 * - UUIDv7 for regular rows (time-ordered, collision-safe across devices);
 * - UUIDv5 (deterministic) for join rows, recurrences and periods, so that two devices
 *   working offline produce the very same row and the server upsert converges (S4, S5, S13).
 */
/** Fixed namespace of the flow project for every deterministic id. Never change it. */
export const FLOW_UUID_NAMESPACE = '6f3b0a2e-1d4c-4f8a-9b7e-2c5d8e1f0a3b';
/** New time-ordered id for a regular row. */
export function newId() {
    return uuidv7();
}
/** Deterministic id derived from the project namespace and a stable name. */
export function deterministicId(name) {
    return uuidv5(name, FLOW_UUID_NAMESPACE);
}
/** Deterministic id derived from another id (nested namespaces, e.g. periods and recurrences). */
export function deterministicChildId(parentId, name) {
    return uuidv5(name, parentId);
}
/** Id of the `block_tags` join row for a block and a tag: identical on every device. */
export function blockTagId(blockId, tagId) {
    return deterministicId(`block_tags:${blockId}:${tagId}`);
}
/** Id of the `field_values` join row for a block and a field definition. */
export function fieldValueId(blockId, fieldId) {
    return deterministicId(`field_values:${blockId}:${fieldId}`);
}
/** Id of the period that follows a closed one: two offline closures converge (docs/08 §5.1). */
export function nextPeriodId(userId, closedPeriodId) {
    return deterministicChildId(userId, `period:${closedPeriodId}`);
}
export function isUuid(value) {
    return uuidValidate(value);
}
//# sourceMappingURL=ids.js.map